/* Shared feature/review dots: observe actual card visibility, no scroll polling. */
window.MCScrollSnapDots ||= class {
  constructor(track, cards, dots, cardSelector, signal) {
    const visibility = new Map();
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => visibility.set(entry.target, entry.intersectionRatio));
      const index = cards.reduce((best, card, i) => (visibility.get(card) || 0) > (visibility.get(cards[best]) || 0) ? i : best, 0);
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }, { root:track, threshold:[0,.25,.5,.75,.99,1] });
    cards.forEach(card => this.observer.observe(card));
    track.addEventListener('focusin', event => event.target.closest(cardSelector)?.scrollIntoView({ block:'nearest', inline:'start' }), { signal });
  }
  disconnect() { this.observer.disconnect(); }
};
